/**
 * @generated SignedSource<<3f8bb99def6e6f15a960a9ee3d9e04cf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "request"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "request",
        "variableName": "request"
      }
    ],
    "concreteType": "Impulse",
    "kind": "LinkedField",
    "name": "updateImpulseStatus",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "version",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ImpulseImplStatusMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ImpulseImplStatusMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "29a0f88be48a31201e164abc0429d05e",
    "id": null,
    "metadata": {},
    "name": "ImpulseImplStatusMutation",
    "operationKind": "mutation",
    "text": "mutation ImpulseImplStatusMutation(\n  $request: UpdateImpulseStatusRequestInput\n) {\n  updateImpulseStatus(request: $request) {\n    id\n    status\n    version\n  }\n}\n"
  }
};
})();

node.hash = "3d154da98594b1a8203edbe15d88e4fc";

module.exports = node;
